import clsx from "clsx";
import { FC } from "react";
import { Heading } from "@/components/Html/Heading";
import { Section } from "@/components/Html/Section";
import { testIds } from "@/test/testId/testIds";
import { ContactLink } from "../ContactLink/ContactLink";

interface Props {
  isPinkBg?: boolean;
}

export const ContactUs: FC<Props> = ({ isPinkBg }) => {
  return (
    <Section
      className={clsx(
        "kdot-container mx-auto flex items-center justify-center !py-[48px]",
        isPinkBg ? "bg-[#FEF1EF]" : "bg-white",
      )}
    >
      <div className="max-w-[700px] justify-center rounded-[32px] bg-[#FFDAD5] p-[24px] text-left md:p-[48px] md:text-center">
        <Heading heading="1" className="mb-[32px] text-[36px] md:text-[45px]">
          まずはお気軽にご連絡下さい
        </Heading>
        <p className="mb-[32px] text-left text-[#00000099]">
          私達は、テクノロジーがもたらす価値を最大化するために支援しています。
        </p>
        <div className="flex justify-center">
          <ContactLink testId={testIds.serivce.contactUs.contactLink} />
        </div>
      </div>
    </Section>
  );
};
